import React, { useState } from 'react'
import { Add as AddIcon } from '@material-ui/icons'

import { FieldSpec, LinkedField, PaginatedTable, ValueField } from 'src/components/Table'
import { DockDialog } from 'src/modules/supply_chain/components/DockDialog'
import { ListTableProps } from './types'
import { Facility } from 'src/api/models'

const fieldOptions: { [key: string]: FieldSpec } = {
  name: { id: 'name', label: 'Name', renderer: LinkedField(ValueField) },
  dockType: { id: 'dockType', label: 'Dock Type', renderer: ValueField },
}

interface DockListTableProps extends ListTableProps {
  facility?: Facility
}

export const DockListTable = (props: DockListTableProps) => {
  const { paginator, fields, title = 'Dock Doors', facility } = props
  const [dockDialogOpen, setDockDialogOpen] = useState(false)

  return (
    <>
      {dockDialogOpen && (
        <DockDialog
          open={dockDialogOpen}
          handleClose={() => setDockDialogOpen(false)}
          facility={facility}
        />
      )}
      <PaginatedTable
        title={title}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        actions={[{ title: 'Add Dock Door', icon: <AddIcon />, onClick: () => setDockDialogOpen(true) }]}
      />
    </>
  )
}
